import Button from "../../../../shared/components/ui/Button";
import AssignedTeacherProgramForm from "./assignedTeacherProgramForm";
import useAssignedTeacherProgram from "../../hooks/teacher/useAssignedTeacherProgram";

export interface AssignedTeacherProgramsProps {
  programId: number;
  setOpenModal: (val: boolean) => void;
}

export default function AssignedTeacherPrograms({
  programId,
  setOpenModal,
}: AssignedTeacherProgramsProps) {
  const { control, loading, handleSubmit } = useAssignedTeacherProgram({
    programId,
    setOpenModal,
  });
  return (
    <form onSubmit={handleSubmit}>
      <AssignedTeacherProgramForm control={control} programId={programId} />
      <div className="mt-9 flex items-center justify-end">
        <Button
          primary
          className="bg-[#072082]"
          loading={loading}
          type="submit"
          variant="filled"
        >
          <i className="fa-solid fa-save" /> Crear
        </Button>
      </div>
    </form>
  );
}
